import { Injectable } from '@angular/core';

import { AnalyticsService } from './analytics.service';

/**
 * Stops (flushes) any in-progress analytics activity when the user enters an
 * area that is intentionally not tracked (e.g. the admin panel). This ensures
 * the previous page's activity does not keep accumulating time in the
 * background; it is closed immediately and no new activity is started here.
 */
@Injectable({
    providedIn: 'root',
})
export class StopActivityGuard {
    constructor(private analyticsService: AnalyticsService) {}

    canActivate(): Promise<boolean> {
        this.analyticsService.stopTracking();
        return Promise.resolve(true);
    }
}
